class SizeChoiceGuard extends HTMLElement {
  static FORM_SELECTOR = 'product-form form';
  static VARIANT_INPUT_SELECTOR = '[data-product-form-variant]';
  static LABEL_SELECTOR = '.product-buy-btn__text-label, .product-buy-btn__text-label-short';
  static PICKER_SELECTOR = 'variant-picker';

  connectedCallback() {
    window.addEventListener('submit', this.onSubmit, true);
  }

  disconnectedCallback() {
    window.removeEventListener('submit', this.onSubmit, true);
  }

  onSubmit = (event) => {
    const form = event.target;
    if (!form?.matches?.(SizeChoiceGuard.FORM_SELECTOR)) return;
    const input = form.querySelector(SizeChoiceGuard.VARIANT_INPUT_SELECTOR);
    if (!input || input.value !== '') return;

    event.preventDefault();
    event.stopImmediatePropagation();
    this.prompt(form);
  };

  prompt(form) {
    const label = this.dataset.label || '';
    form.querySelectorAll('button[type="submit"]').forEach((button) => {
      const spans = button.querySelectorAll(SizeChoiceGuard.LABEL_SELECTOR);
      if (spans.length) {
        spans.forEach((span) => (span.textContent = label));
      } else {
        const text = button.querySelector('[data-button-text]');
        if (text) text.textContent = label;
      }
      button.setAttribute('aria-label', label);
    });

    const scope = form.closest('.shopify-section') || document;
    const picker = scope.querySelector(SizeChoiceGuard.PICKER_SELECTOR);
    if (!picker) return;
    const rect = picker.getBoundingClientRect();
    if (rect.top < 0 || rect.bottom > window.innerHeight) {
      picker.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }
}

if (!customElements.get('size-choice-guard')) {
  customElements.define('size-choice-guard', SizeChoiceGuard);
}
